import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface HelpFilledSmallProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const HelpFilledSmall = forwardRef<SVGSVGElement, HelpFilledSmallProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.indigo20}
          fillRule='evenodd'
          d='M12 21.972c5.505 0 9.968-4.463 9.968-9.968S17.505 2.036 12 2.036 2.032 6.5 2.032 12.004 6.495 21.972 12 21.972'
          clipRule='evenodd'
        ></path>
        <path
          fill={secondaryColor ?? '#4B49A2'}
          fillRule='evenodd'
          d='M8.85 7.181a3.702 3.702 0 0 1 4.084-1.855c1.075.25 2.052 1.006 2.52 2.03a3.676 3.676 0 0 1-1.097 4.442c-.627.48-1.132.946-1.132 1.681 0 .83-.662 1.51-1.488 1.51-.825 0-1.487-.68-1.487-1.51 0-1.366.65-2.818 1.769-3.673a6.67 6.67 0 0 1 .159-.116c.362-.26.802-.574.578-1.063a.607.607 0 0 0-.414-.342c-.369-.085-.72.047-.907.39a1.476 1.476 0 0 1-2.024.587 1.521 1.521 0 0 1-.578-2.05l.017-.03m2.957 11.59a1.5 1.5 0 1 0-.238-2.99 1.5 1.5 0 0 0 .238 2.99'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

HelpFilledSmall.displayName = 'HelpFilledSmall';

export default HelpFilledSmall;
